import type { SeverityLevel } from '@sentry/node';
import type { FuuzeErrorMessage } from '../utils/error.util.js';

type Message = FuuzeErrorMessage | (string & {});
type Code = number | string;

export class FuuzeError extends Error {
  code: number | string;
  info?: any;
  level: SeverityLevel;
  override message: FuuzeErrorMessage | (string & {});
  reason?: string;
  ignoreSendingToTrackingTool?: boolean;

  constructor(params: {
    message?: Message;
    code?: Code;
    reason?: string;
    info?: any;
    level?: SeverityLevel;
    ignoreSendingToTrackingTool?: boolean;
  });
  constructor(message?: Message, code?: Code, reason?: string, info?: any, level?: SeverityLevel);
  constructor(
    messageOrParams:
      | (Message | undefined)
      | {
          message?: Message;
          code?: Code;
          reason?: string;
          info?: any;
          level?: SeverityLevel;
          ignoreSendingToTrackingTool?: boolean;
        },
    code?: Code,
    reason?: string,
    info?: any,
    level?: SeverityLevel,
  ) {
    if (typeof messageOrParams === 'object' && messageOrParams !== null && 'message' in messageOrParams) {
      // Handle object parameter overload
      const params = messageOrParams;
      super(params.message);
      this.code = params.code || 500;
      this.info = params.info;
      this.level = params.level || 'error';
      this.message = params.message || 'other/generic';
      this.reason = params.reason;
      this.ignoreSendingToTrackingTool = params.ignoreSendingToTrackingTool;
    } else {
      // Handle positional parameter overload
      const message = messageOrParams as FuuzeErrorMessage | (string & {});
      super(message);
      this.code = code || 500;
      this.info = info;
      this.level = level || 'error';
      this.message = message || 'other/generic';
      this.reason = reason;
    }

    if (this.message === 'other/not-found') {
      this.code = 404;
    }

    if (this.message === 'other/wrong-input') {
      this.code = 400;
    }

    if (this.message === 'other/forbidden') {
      this.code = 403;
    }
  }

  toJSON() {
    return {
      code: this.code,
      info: this.info,
      level: this.level,
      message: this.message,
      reason: this.reason,
    };
  }
}
